import React from "react";
import NotInformation from "../../../../components/NotInformation";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import UnitDetailsModal from "../../Modal/UnitDetailsModal";
import UnitAssignedCard from "./UnitAssignedCard";
import { UnitsListApp } from "../../Functionality/UnitsListApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Units of the building detail, same searchable card grid as the residents tabs
 * with the actions menu of each unit.
 *
 * @param {Object} props.buildingDetail - Building the units belong to.
 */
const UnitsList = ({ buildingDetail }) => {
    const {
        t,
        option,
        searchElement,
        setSearchElement,
        results,
        setResults,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        handleSearch,
        handleResetSearch,
        detailsModal,
        selectedItem,
        hideDetails,
        getActionsButtons,
        pagination,
        elementRef
    } = UnitsListApp({ buildingId: buildingDetail?.id });

    return (
        <>
            <div className="row my-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={"txt_unl_search_simple"}
                        label={'search_by_name'}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setResults}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        callApi={handleSearch}
                        resetApi={handleResetSearch}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ? (
                <>
                    <div className={"panelTables-container custom-scrollbar"} ref={elementRef}>
                        <div className={"row"}>
                            {
                                results.content.map((unit, index) => (
                                    <div className='col-sm-12 col-md-4 col-lg-3 mb-3 px-1' key={unit?.id}>
                                        <UnitAssignedCard
                                            t={t}
                                            keyId={'id'}
                                            item={unit}
                                            actions={getActionsButtons(unit, index)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={"flex-shrink-0"}>
                        {pagination()}
                    </div>
                </>
            ) : (
                <NotInformation
                    text={searchElement === "" ? t('you_have_not_assigned_any_unit_yet') : t("no_results_found")}
                    card={true}
                    className={"h-100"}
                />
            )}

            <UnitDetailsModal
                show={detailsModal}
                onHide={hideDetails}
                item={selectedItem}
            />
        </>
    );
};

export default UnitsList;
